import React from 'react'
import Loader from 'react-loader-spinner'
import { Highlighter } from 'react-bootstrap-typeahead'

const SearchResultItem = ({ item, inputText, currentReportId }) => {
  const url = item.category_id ? `/admin/org/categories/${item.category_id}/reports/${item.id}` : `/admin/org/reports/${item.id}`

  return (
    <a href={url} >
      <div className='search-result-row p-4 border-bottom'>
        <div className='row'>
          <div className='col-sm-3 col-md-3 col-lg-2 d-none d-sm-block'>
            <div className='d-inline-block px-2 text-grey category'>
              {item.category}
            </div>
          </div>
          <div className='col-12 col-sm-7 col-md-9 col-lg-10'>
            {currentReportId === item.id && (
              <div className='d-inline-block mb-2 px-2 py-1 bg-grey text-black badge'>
                Current Report
              </div>
            ) }
            <div className='mt'>
              <Highlighter search={inputText}>{item.name}</Highlighter>
            </div>
            <div className='mt-2'>
              <span className='text-grey description'>
                {item.description && <Highlighter search={inputText}>{item.description}</Highlighter>}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default function SearchResults({ inputText, searchResults, currentReportId, hasFocus }) {
  if (!inputText || !hasFocus) return null

  if (!searchResults || (searchResults && searchResults.loading)) {
    return (
      <div className='text-center report-search-results position-absolute'>
        <Loader type='ThreeDots' color='#00BFFF' height={80} width={80} />
      </div>
    )
  }

  if (
    (searchResults.result && searchResults.result.error) ||
    !searchResults.result ||
    searchResults.result.length === 0
  ) {
    return (
      <div className='text-center report-search-results position-absolute'>
        <p className='text-muted'>No results found</p>
      </div>
    )
  }

  return (
    <div className='report-search-results position-absolute'>
      {searchResults.result.map(item => (
        <SearchResultItem
          key={item.id}
          item={item}
          inputText={inputText}
          currentReportId={currentReportId}
        />
      ))}
    </div>
  )
}
